const mockData = [

     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200519T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MTlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-19T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-19T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-05-19T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200520T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-20T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-20T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-05-20T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200521T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-21T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-21T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-05-21T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200522T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-22T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-22T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-05-22T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200523T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-23T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-23T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-05-23T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200525T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-25T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-25T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-05-25T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200526T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-26T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-26T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-05-26T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200527T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-27T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-27T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-05-27T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200528T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjhUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-28T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-28T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-05-28T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200529T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-29T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-29T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-05-29T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200530T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MzBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-05-30T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-05-30T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-05-30T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200601T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-01T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-01T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-01T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200602T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-02T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-02T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-02T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200603T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-03T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-03T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-03T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200604T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDRUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-04T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-04T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-04T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200605T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-05T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-05T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-05T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200606T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-06T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-06T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-06T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200608T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDhUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-08T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-08T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-08T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200609T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-09T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-09T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-09T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200610T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-10T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-10T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-10T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200611T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MTFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-11T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-11T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-11T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200612T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-12T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-12T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-12T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200613T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MTNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-13T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-13T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-13T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200615T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-15T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-15T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-15T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200616T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MTZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-16T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-16T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-16T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200617T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-17T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-17T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-17T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200618T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MThUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-18T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-18T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-18T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200619T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-19T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-19T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-19T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200620T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-20T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-20T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-20T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200622T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MjJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-22T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-22T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-22T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200623T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-23T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-23T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-23T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200624T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MjRUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-24T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-24T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-24T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200625T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-25T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-25T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-25T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200626T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MjZUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-26T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-26T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-26T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200627T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjdUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-27T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-27T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-27T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200628T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA2MjhUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-29T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-29T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-06-29T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200629T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MjlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-29T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-29T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-06-29T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200629T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA2MjlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-29T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-29T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-06-29T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200629T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA2MjlUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-29T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-29T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-06-29T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221506816000\"",
      "id": "48m09le389vijbqfs2mcr6i87q_20200630T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDhtMDlsZTM4OXZpamJxZnMybWNyNmk4N3FfMjAyMDA2MzBUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:39:01.000Z",
      "updated": "2020-07-01T13:39:13.408Z",
      "summary": "Node Gang",
      "description": "We meet every Tuesday to talk about Node or JavaScript in general. Node Gang is an inclusive community that tries to cater to all levels of learners during meetups. Join us if you are curious to hear about what's new in Node, patterns, interesting npm packages, and practices.",
      "location": "Sydney NSW, Australia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-30T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-30T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "48m09le389vijbqfs2mcr6i87q",
      "originalStartTime": {
       "dateTime": "2020-06-30T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "48m09le389vijbqfs2mcr6i87q@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wdc-wutt-tji",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wdc-wutt-tji",
         "label": "meet.google.com/wdc-wutt-tji"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wdc-wutt-tji?pin=3796108774207",
         "pin": "3796108774207"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618974",
         "label": "+49 40 8081618974",
         "pin": "170634768"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wdc-wutt-tji",
       "signature": "AGirE/LhFDA0pcP/2mptu9nEhNEy"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200630T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA2MzBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-30T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-30T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-06-30T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200630T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MzBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-30T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-30T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-06-30T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187238088812000\"",
      "id": "7e4k9oop7bb86svd42vui37k6o_20200630T150000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N2U0azlvb3A3YmI4NnN2ZDQydnVpMzdrNm9fMjAyMDA2MzBUMTUwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:56:05.000Z",
      "updated": "2020-07-01T15:57:24.406Z",
      "summary": "Angular Moscow",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Moscow, Russia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-30T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-30T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7e4k9oop7bb86svd42vui37k6o",
      "originalStartTime": {
       "dateTime": "2020-06-30T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7e4k9oop7bb86svd42vui37k6o@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/fip-gdth-tdu",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/fip-gdth-tdu",
         "label": "meet.google.com/fip-gdth-tdu"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/fip-gdth-tdu?pin=1369000914291",
         "pin": "1369000914291"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616684",
         "label": "+49 40 8081616684",
         "pin": "516915292"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "fip-gdth-tdu",
       "signature": "AGirE/L64btreJwJIDJq962dEZU0"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200630T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA2MzBUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-06-30T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-06-30T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-06-30T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200630T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA2MzBUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-01T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200701T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MDFUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-01T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200701T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MDFUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-01T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200701T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MDFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-01T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200701T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MDFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-01T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200701T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MDFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-01T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200701T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MDFUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-01T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200701T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MDFUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-01T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-01T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-01T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200702T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MDJUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-02T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-02T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-02T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200702T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MDJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-02T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-02T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-02T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200702T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MDJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-02T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-02T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-02T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200702T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MDJUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-02T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-02T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-02T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200702T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MDJUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-03T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-03T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-03T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200703T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MDNUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-03T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-03T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-03T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200703T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MDNUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-03T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-03T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-03T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200703T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MDNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-03T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-03T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-03T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200703T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MDNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-03T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-03T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-03T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200703T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MDNUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-03T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-03T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-03T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200704T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MDRUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-04T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-04T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-04T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200704T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MDRUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-04T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-04T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-04T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200704T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MDRUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-04T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-04T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-04T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200705T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MDVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-05T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-05T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-05T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200705T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MDVUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-05T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-05T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-05T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200705T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MDVUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-06T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-06T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-06T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200706T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MDZUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-06T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-06T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-06T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200706T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MDZUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-06T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-06T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-06T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200706T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MDZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-06T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-06T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-06T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200706T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MDZUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-06T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-06T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-06T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200706T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MDZUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-06T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-06T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-06T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221506816000\"",
      "id": "48m09le389vijbqfs2mcr6i87q_20200707T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDhtMDlsZTM4OXZpamJxZnMybWNyNmk4N3FfMjAyMDA3MDdUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:39:01.000Z",
      "updated": "2020-07-01T13:39:13.408Z",
      "summary": "Node Gang",
      "description": "We meet every Tuesday to talk about Node or JavaScript in general. Node Gang is an inclusive community that tries to cater to all levels of learners during meetups. Join us if you are curious to hear about what's new in Node, patterns, interesting npm packages, and practices.",
      "location": "Sydney NSW, Australia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-07T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-07T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "48m09le389vijbqfs2mcr6i87q",
      "originalStartTime": {
       "dateTime": "2020-07-07T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "48m09le389vijbqfs2mcr6i87q@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wdc-wutt-tji",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wdc-wutt-tji",
         "label": "meet.google.com/wdc-wutt-tji"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wdc-wutt-tji?pin=3796108774207",
         "pin": "3796108774207"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618974",
         "label": "+49 40 8081618974",
         "pin": "170634768"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wdc-wutt-tji",
       "signature": "AGirE/LhFDA0pcP/2mptu9nEhNEy"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200707T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MDdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-07T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-07T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-07T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200707T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MDdUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-07T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-07T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-07T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187238088812000\"",
      "id": "7e4k9oop7bb86svd42vui37k6o_20200707T150000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N2U0azlvb3A3YmI4NnN2ZDQydnVpMzdrNm9fMjAyMDA3MDdUMTUwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:56:05.000Z",
      "updated": "2020-07-01T15:57:24.406Z",
      "summary": "Angular Moscow",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Moscow, Russia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-07T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-07T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7e4k9oop7bb86svd42vui37k6o",
      "originalStartTime": {
       "dateTime": "2020-07-07T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7e4k9oop7bb86svd42vui37k6o@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/fip-gdth-tdu",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/fip-gdth-tdu",
         "label": "meet.google.com/fip-gdth-tdu"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/fip-gdth-tdu?pin=1369000914291",
         "pin": "1369000914291"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616684",
         "label": "+49 40 8081616684",
         "pin": "516915292"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "fip-gdth-tdu",
       "signature": "AGirE/L64btreJwJIDJq962dEZU0"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200707T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MDdUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-07T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-07T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-07T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200707T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MDdUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-08T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200708T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MDhUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-08T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200708T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MDhUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-08T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200708T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MDhUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-08T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200708T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MDhUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-08T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200708T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MDhUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-08T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200708T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MDhUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-08T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200708T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MDhUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-08T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-08T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-08T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200709T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MDlUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-09T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-09T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-09T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200709T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MDlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-09T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-09T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-09T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200709T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MDlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-09T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-09T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-09T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200709T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MDlUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-09T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-09T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-09T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200709T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MDlUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-10T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-10T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-10T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200710T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MTBUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-10T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-10T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-10T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200710T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MTBUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-10T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-10T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-10T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200710T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MTBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-10T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-10T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-10T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200710T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MTBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-10T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-10T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-10T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200710T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MTBUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-10T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-10T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-10T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200711T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MTFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-11T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-11T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-11T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200711T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MTFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-11T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-11T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-11T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200711T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MTFUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-11T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-11T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-11T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200712T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MTJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-12T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-12T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-12T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200712T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MTJUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-12T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-12T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-12T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200712T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MTJUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-13T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-13T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-13T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200713T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MTNUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-13T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-13T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-13T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200713T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MTNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-13T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-13T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-13T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200713T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MTNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-13T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-13T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-13T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200713T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MTNUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-13T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-13T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-13T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200713T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MTNUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-13T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-13T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-13T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221506816000\"",
      "id": "48m09le389vijbqfs2mcr6i87q_20200714T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDhtMDlsZTM4OXZpamJxZnMybWNyNmk4N3FfMjAyMDA3MTRUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:39:01.000Z",
      "updated": "2020-07-01T13:39:13.408Z",
      "summary": "Node Gang",
      "description": "We meet every Tuesday to talk about Node or JavaScript in general. Node Gang is an inclusive community that tries to cater to all levels of learners during meetups. Join us if you are curious to hear about what's new in Node, patterns, interesting npm packages, and practices.",
      "location": "Sydney NSW, Australia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-14T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-14T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "48m09le389vijbqfs2mcr6i87q",
      "originalStartTime": {
       "dateTime": "2020-07-14T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "48m09le389vijbqfs2mcr6i87q@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wdc-wutt-tji",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wdc-wutt-tji",
         "label": "meet.google.com/wdc-wutt-tji"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wdc-wutt-tji?pin=3796108774207",
         "pin": "3796108774207"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618974",
         "label": "+49 40 8081618974",
         "pin": "170634768"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wdc-wutt-tji",
       "signature": "AGirE/LhFDA0pcP/2mptu9nEhNEy"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200714T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MTRUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-14T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-14T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-14T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200714T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MTRUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-14T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-14T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-14T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187238088812000\"",
      "id": "7e4k9oop7bb86svd42vui37k6o_20200714T150000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N2U0azlvb3A3YmI4NnN2ZDQydnVpMzdrNm9fMjAyMDA3MTRUMTUwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:56:05.000Z",
      "updated": "2020-07-01T15:57:24.406Z",
      "summary": "Angular Moscow",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Moscow, Russia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-14T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-14T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7e4k9oop7bb86svd42vui37k6o",
      "originalStartTime": {
       "dateTime": "2020-07-14T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7e4k9oop7bb86svd42vui37k6o@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/fip-gdth-tdu",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/fip-gdth-tdu",
         "label": "meet.google.com/fip-gdth-tdu"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/fip-gdth-tdu?pin=1369000914291",
         "pin": "1369000914291"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616684",
         "label": "+49 40 8081616684",
         "pin": "516915292"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "fip-gdth-tdu",
       "signature": "AGirE/L64btreJwJIDJq962dEZU0"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200714T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MTRUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-14T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-14T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-14T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200714T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MTRUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-15T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200715T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MTVUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-15T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200715T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MTVUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-15T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200715T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MTVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-15T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200715T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MTVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-15T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200715T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MTVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-15T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200715T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MTVUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-15T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200715T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MTVUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-15T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-15T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-15T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200716T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MTZUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-16T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-16T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-16T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200716T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MTZUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-16T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-16T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-16T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200716T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MTZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-16T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-16T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-16T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200716T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MTZUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-16T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-16T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-16T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200716T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MTZUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-17T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-17T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-17T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200717T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MTdUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-17T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-17T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-17T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200717T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MTdUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-17T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-17T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-17T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200717T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MTdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-17T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-17T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-17T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200717T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MTdUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-17T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-17T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-17T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200717T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MTdUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-17T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-17T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-17T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200718T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MThUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-18T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-18T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-18T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200718T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MThUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-18T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-18T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-18T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200718T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MThUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-18T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-18T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-18T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200719T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MTlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-19T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-19T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-19T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200719T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MTlUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-19T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-19T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-19T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200719T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MTlUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-20T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-20T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-20T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200720T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MjBUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-20T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-20T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-20T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200720T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MjBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-20T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-20T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-20T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200720T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MjBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-20T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-20T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-20T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200720T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MjBUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-20T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-20T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-20T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200720T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MjBUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-20T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-20T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-20T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221506816000\"",
      "id": "48m09le389vijbqfs2mcr6i87q_20200721T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDhtMDlsZTM4OXZpamJxZnMybWNyNmk4N3FfMjAyMDA3MjFUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:39:01.000Z",
      "updated": "2020-07-01T13:39:13.408Z",
      "summary": "Node Gang",
      "description": "We meet every Tuesday to talk about Node or JavaScript in general. Node Gang is an inclusive community that tries to cater to all levels of learners during meetups. Join us if you are curious to hear about what's new in Node, patterns, interesting npm packages, and practices.",
      "location": "Sydney NSW, Australia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-21T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-21T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "48m09le389vijbqfs2mcr6i87q",
      "originalStartTime": {
       "dateTime": "2020-07-21T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "48m09le389vijbqfs2mcr6i87q@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wdc-wutt-tji",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wdc-wutt-tji",
         "label": "meet.google.com/wdc-wutt-tji"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wdc-wutt-tji?pin=3796108774207",
         "pin": "3796108774207"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618974",
         "label": "+49 40 8081618974",
         "pin": "170634768"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wdc-wutt-tji",
       "signature": "AGirE/LhFDA0pcP/2mptu9nEhNEy"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200721T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MjFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-21T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-21T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-21T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200721T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MjFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-21T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-21T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-21T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187238088812000\"",
      "id": "7e4k9oop7bb86svd42vui37k6o_20200721T150000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N2U0azlvb3A3YmI4NnN2ZDQydnVpMzdrNm9fMjAyMDA3MjFUMTUwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:56:05.000Z",
      "updated": "2020-07-01T15:57:24.406Z",
      "summary": "Angular Moscow",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Moscow, Russia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-21T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-21T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7e4k9oop7bb86svd42vui37k6o",
      "originalStartTime": {
       "dateTime": "2020-07-21T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7e4k9oop7bb86svd42vui37k6o@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/fip-gdth-tdu",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/fip-gdth-tdu",
         "label": "meet.google.com/fip-gdth-tdu"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/fip-gdth-tdu?pin=1369000914291",
         "pin": "1369000914291"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616684",
         "label": "+49 40 8081616684",
         "pin": "516915292"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "fip-gdth-tdu",
       "signature": "AGirE/L64btreJwJIDJq962dEZU0"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200721T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MjFUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-21T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-21T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-21T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200721T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MjFUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-22T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200722T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MjJUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-22T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200722T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MjJUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-22T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200722T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MjJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-22T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200722T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MjJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-22T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200722T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MjJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-22T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200722T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MjJUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-22T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200722T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MjJUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-22T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-22T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-22T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200723T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MjNUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-23T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-23T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-23T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200723T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MjNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-23T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-23T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-23T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200723T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MjNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-23T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-23T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-23T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200723T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MjNUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-23T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-23T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-23T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200723T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MjNUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-24T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-24T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-24T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200724T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MjRUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-24T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-24T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-24T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200724T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MjRUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-24T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-24T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-24T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200724T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MjRUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-24T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-24T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-24T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200724T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MjRUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-24T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-24T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-24T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200724T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MjRUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-24T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-24T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-24T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200725T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MjVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-25T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-25T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-25T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200725T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MjVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-25T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-25T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-25T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200725T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MjVUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-25T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-25T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-25T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200726T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MjZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-26T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-26T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-26T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200726T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MjZUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-26T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-26T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-26T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200726T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MjZUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-27T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-27T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-27T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200727T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MjdUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-27T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-27T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-27T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200727T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MjdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-27T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-27T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-27T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200727T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MjdUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-27T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-27T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-27T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200727T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MjdUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-27T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-27T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-27T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200727T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MjdUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-27T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-27T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-27T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221506816000\"",
      "id": "48m09le389vijbqfs2mcr6i87q_20200728T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDhtMDlsZTM4OXZpamJxZnMybWNyNmk4N3FfMjAyMDA3MjhUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:39:01.000Z",
      "updated": "2020-07-01T13:39:13.408Z",
      "summary": "Node Gang",
      "description": "We meet every Tuesday to talk about Node or JavaScript in general. Node Gang is an inclusive community that tries to cater to all levels of learners during meetups. Join us if you are curious to hear about what's new in Node, patterns, interesting npm packages, and practices.",
      "location": "Sydney NSW, Australia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-28T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-28T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "48m09le389vijbqfs2mcr6i87q",
      "originalStartTime": {
       "dateTime": "2020-07-28T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "48m09le389vijbqfs2mcr6i87q@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wdc-wutt-tji",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wdc-wutt-tji",
         "label": "meet.google.com/wdc-wutt-tji"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wdc-wutt-tji?pin=3796108774207",
         "pin": "3796108774207"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618974",
         "label": "+49 40 8081618974",
         "pin": "170634768"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wdc-wutt-tji",
       "signature": "AGirE/LhFDA0pcP/2mptu9nEhNEy"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200728T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MjhUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-28T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-28T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-28T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200728T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MjhUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-28T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-28T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-28T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187238088812000\"",
      "id": "7e4k9oop7bb86svd42vui37k6o_20200728T150000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N2U0azlvb3A3YmI4NnN2ZDQydnVpMzdrNm9fMjAyMDA3MjhUMTUwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:56:05.000Z",
      "updated": "2020-07-01T15:57:24.406Z",
      "summary": "Angular Moscow",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Moscow, Russia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-28T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-28T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7e4k9oop7bb86svd42vui37k6o",
      "originalStartTime": {
       "dateTime": "2020-07-28T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7e4k9oop7bb86svd42vui37k6o@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/fip-gdth-tdu",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/fip-gdth-tdu",
         "label": "meet.google.com/fip-gdth-tdu"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/fip-gdth-tdu?pin=1369000914291",
         "pin": "1369000914291"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616684",
         "label": "+49 40 8081616684",
         "pin": "516915292"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "fip-gdth-tdu",
       "signature": "AGirE/L64btreJwJIDJq962dEZU0"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200728T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA3MjhUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-28T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-28T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-07-28T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200728T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MjhUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-29T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200729T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MjlUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-29T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200729T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MjlUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-29T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200729T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MjlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-29T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200729T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MjlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-29T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200729T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA3MjlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-07-29T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200729T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA3MjlUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-07-29T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200729T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MjlUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-29T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-29T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-29T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200730T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA3MzBUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-30T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-30T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-07-30T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200730T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA3MzBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-30T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-30T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-07-30T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200730T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA3MzBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-30T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-30T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-07-30T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200730T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA3MzBUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-30T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-30T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-07-30T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200730T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA3MzBUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-31T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-31T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-07-31T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200731T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA3MzFUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-31T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-31T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-07-31T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200731T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA3MzFUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-31T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-31T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-07-31T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200731T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA3MzFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-31T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-31T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-07-31T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200731T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA3MzFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-31T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-31T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-07-31T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200731T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA3MzFUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-07-31T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-07-31T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-07-31T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200801T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA4MDFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-01T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-01T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-08-01T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200801T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA4MDFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-01T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-01T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-08-01T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200801T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA4MDFUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-01T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-01T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-08-01T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200802T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA4MDJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-02T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-02T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-08-02T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200802T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA4MDJUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-02T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-02T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-08-02T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200802T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA4MDJUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-03T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-03T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-08-03T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200803T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA4MDNUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-03T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-03T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-08-03T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200803T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA4MDNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-03T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-03T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-08-03T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200803T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA4MDNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-03T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-03T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-08-03T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200803T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA4MDNUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-03T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-03T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-08-03T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200803T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA4MDNUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-03T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-03T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-08-03T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221506816000\"",
      "id": "48m09le389vijbqfs2mcr6i87q_20200804T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDhtMDlsZTM4OXZpamJxZnMybWNyNmk4N3FfMjAyMDA4MDRUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:39:01.000Z",
      "updated": "2020-07-01T13:39:13.408Z",
      "summary": "Node Gang",
      "description": "We meet every Tuesday to talk about Node or JavaScript in general. Node Gang is an inclusive community that tries to cater to all levels of learners during meetups. Join us if you are curious to hear about what's new in Node, patterns, interesting npm packages, and practices.",
      "location": "Sydney NSW, Australia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-04T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-04T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "48m09le389vijbqfs2mcr6i87q",
      "originalStartTime": {
       "dateTime": "2020-08-04T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "48m09le389vijbqfs2mcr6i87q@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wdc-wutt-tji",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wdc-wutt-tji",
         "label": "meet.google.com/wdc-wutt-tji"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wdc-wutt-tji?pin=3796108774207",
         "pin": "3796108774207"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618974",
         "label": "+49 40 8081618974",
         "pin": "170634768"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wdc-wutt-tji",
       "signature": "AGirE/LhFDA0pcP/2mptu9nEhNEy"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200804T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA4MDRUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-04T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-04T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-08-04T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200804T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA4MDRUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-04T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-04T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-08-04T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187238088812000\"",
      "id": "7e4k9oop7bb86svd42vui37k6o_20200804T150000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N2U0azlvb3A3YmI4NnN2ZDQydnVpMzdrNm9fMjAyMDA4MDRUMTUwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:56:05.000Z",
      "updated": "2020-07-01T15:57:24.406Z",
      "summary": "Angular Moscow",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Moscow, Russia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-04T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-04T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7e4k9oop7bb86svd42vui37k6o",
      "originalStartTime": {
       "dateTime": "2020-08-04T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7e4k9oop7bb86svd42vui37k6o@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/fip-gdth-tdu",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/fip-gdth-tdu",
         "label": "meet.google.com/fip-gdth-tdu"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/fip-gdth-tdu?pin=1369000914291",
         "pin": "1369000914291"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616684",
         "label": "+49 40 8081616684",
         "pin": "516915292"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "fip-gdth-tdu",
       "signature": "AGirE/L64btreJwJIDJq962dEZU0"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200804T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA4MDRUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-04T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-04T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-08-04T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200804T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA4MDRUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-08-05T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200805T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA4MDVUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-08-05T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200805T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA4MDVUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-08-05T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200805T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA4MDVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-08-05T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200805T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA4MDVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-08-05T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200805T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA4MDVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-08-05T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200805T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA4MDVUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-08-05T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200805T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA4MDVUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-05T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-05T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-08-05T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200806T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA4MDZUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-06T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-06T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-08-06T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200806T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA4MDZUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-06T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-06T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-08-06T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200806T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA4MDZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-06T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-06T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-08-06T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200806T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA4MDZUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-06T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-06T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-08-06T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200806T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA4MDZUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-07T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-07T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-08-07T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200807T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA4MDdUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-07T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-07T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-08-07T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232499498000\"",
      "id": "7rclpdp8egm60g7kepei7j0bt9_20200807T090000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3JjbHBkcDhlZ202MGc3a2VwZWk3ajBidDlfMjAyMDA4MDdUMDkwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:10:03.000Z",
      "updated": "2020-07-01T15:10:49.749Z",
      "summary": "Hello JavaScript!!",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? You are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:- Learn JavaScript, from basics to advanced topics- Create your first app",
      "location": "Bangkok, Thailand",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-07T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-07T12:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7rclpdp8egm60g7kepei7j0bt9",
      "originalStartTime": {
       "dateTime": "2020-08-07T11:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7rclpdp8egm60g7kepei7j0bt9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/tbu-cgma-ikb",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/tbu-cgma-ikb",
         "label": "meet.google.com/tbu-cgma-ikb"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/tbu-cgma-ikb?pin=5464596701700",
         "pin": "5464596701700"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618071",
         "label": "+49 40 8081618071",
         "pin": "382271360"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "tbu-cgma-ikb",
       "signature": "AGirE/JMEW9+pm1Esv5ik3OMrH7A"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200807T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA4MDdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-07T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-07T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-08-07T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200807T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA4MDdUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-07T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-07T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-08-07T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200807T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA4MDdUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-07T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-07T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-08-07T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200808T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA4MDhUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-08T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-08T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-08-08T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200808T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA4MDhUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-08T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-08T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-08-08T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200808T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA4MDhUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-08T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-08T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-08-08T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187231386852000\"",
      "id": "7qqm95l3op6khilck5cprvbq2u_20200809T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N3FxbTk1bDNvcDZraGlsY2s1Y3BydmJxMnVfMjAyMDA4MDlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:00:58.000Z",
      "updated": "2020-07-01T15:01:33.426Z",
      "summary": "Fun with Angular",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "Dubai - United Arab Emirates",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-09T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-09T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7qqm95l3op6khilck5cprvbq2u",
      "originalStartTime": {
       "dateTime": "2020-08-09T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7qqm95l3op6khilck5cprvbq2u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/bim-zvvi-nio",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/bim-zvvi-nio",
         "label": "meet.google.com/bim-zvvi-nio"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/bim-zvvi-nio?pin=8340594476418",
         "pin": "8340594476418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617267",
         "label": "+49 40 8081617267",
         "pin": "692195842"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "bim-zvvi-nio",
       "signature": "AGirE/LuFdq5duwwWs+tztwtEG9B"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234769062000\"",
      "id": "46717o686s7ibj1lp300pabro9_20200809T180000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDY3MTdvNjg2czdpYmoxbHAzMDBwYWJybzlfMjAyMDA4MDlUMTgwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:28:56.000Z",
      "updated": "2020-07-01T15:29:44.531Z",
      "summary": "React Workshop",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Toronto, ON, Canada",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-09T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-09T21:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "46717o686s7ibj1lp300pabro9",
      "originalStartTime": {
       "dateTime": "2020-08-09T20:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "46717o686s7ibj1lp300pabro9@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/jnj-edux-duq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/jnj-edux-duq",
         "label": "meet.google.com/jnj-edux-duq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/jnj-edux-duq?pin=3356856978418",
         "pin": "3356856978418"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195194",
         "label": "+49 30 300195194",
         "pin": "599388176"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "jnj-edux-duq",
       "signature": "AGirE/LvoztfSZ5PVG7k7gmhVqyJ"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200809T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA4MDlUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-10T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-10T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-08-10T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187237556010000\"",
      "id": "111vmlbl7p8gmc0fbf5u107p8u_20200810T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MTExdm1sYmw3cDhnbWMwZmJmNXUxMDdwOHVfMjAyMDA4MTBUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:47:59.000Z",
      "updated": "2020-07-01T15:52:58.005Z",
      "summary": "React Native Tokyo",
      "description": "We meet every Monday and Thursday to talk about React Native and native app development in general. React Native Tokyo is an inclusive community that tries to cater to all levels of learners during meetups. \n\nJoin us if you are curious to hear about what's new in the field of native app development.",
      "location": "Tokyo, Japan",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-10T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-10T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "111vmlbl7p8gmc0fbf5u107p8u",
      "originalStartTime": {
       "dateTime": "2020-08-10T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "111vmlbl7p8gmc0fbf5u107p8u@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ceo-behe-ssp",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ceo-behe-ssp",
         "label": "meet.google.com/ceo-behe-ssp"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ceo-behe-ssp?pin=2641490783465",
         "pin": "2641490783465"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617770",
         "label": "+49 40 8081617770",
         "pin": "889553795"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ceo-behe-ssp",
       "signature": "AGirE/JaL/DB2RyTMxMcHv3/9v58"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200810T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA4MTBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-10T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-10T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
       "dateTime": "2020-08-10T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187234500432000\"",
      "id": "65jg7h2f96klim15fie75mj1a1_20200810T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NjVqZzdoMmY5NmtsaW0xNWZpZTc1bWoxYTFfMjAyMDA4MTBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:26:57.000Z",
      "updated": "2020-07-01T15:27:30.216Z",
      "summary": "AngularJS Workshop",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Cape Town, South Africa",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-10T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-10T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "65jg7h2f96klim15fie75mj1a1",
      "originalStartTime": {
       "dateTime": "2020-08-10T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "65jg7h2f96klim15fie75mj1a1@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/ctp-pwtc-pmq",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/ctp-pwtc-pmq",
         "label": "meet.google.com/ctp-pwtc-pmq"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/ctp-pwtc-pmq?pin=2824243883315",
         "pin": "2824243883315"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-30-300195220",
         "label": "+49 30 300195220",
         "pin": "987090091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "ctp-pwtc-pmq",
       "signature": "AGirE/IQQTa9Vuy9hN+VDhEX7QNI"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187224991890000\"",
      "id": "3glt4dve9uip7oh5g5kb2bid2s_20200810T160000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dsdDRkdmU5dWlwN29oNWc1a2IyYmlkMnNfMjAyMDA4MTBUMTYwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:07:59.000Z",
      "updated": "2020-07-01T14:08:15.945Z",
      "summary": "Fun with Node.js",
      "description": "Do you know that Node.js is basically a server having the capability of executing JavaScript? If you are familiar with JS, Node.js will be an easy ride. \n\nJoin us if you want to learn how to build the server-side of an app using Node.js.",
      "location": "Nairobi, Kenya",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-10T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-10T19:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3glt4dve9uip7oh5g5kb2bid2s",
      "originalStartTime": {
       "dateTime": "2020-08-10T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3glt4dve9uip7oh5g5kb2bid2s@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wkx-akyy-omd",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wkx-akyy-omd",
         "label": "meet.google.com/wkx-akyy-omd"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wkx-akyy-omd?pin=9536747460380",
         "pin": "9536747460380"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616512",
         "label": "+49 40 8081616512",
         "pin": "576339034"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wkx-akyy-omd",
       "signature": "AGirE/Ielm/IWcKMVRqC0BqOJCpa"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221858184000\"",
      "id": "3gi3kabkm3bua5lq3jhscc8s4c_20200810T200000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M2dpM2thYmttM2J1YTVscTNqaHNjYzhzNGNfMjAyMDA4MTBUMjAwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:23:24.000Z",
      "updated": "2020-07-01T13:42:09.092Z",
      "summary": "Intro to AngularJS-Remote",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. Join us to get introduced to this wonderful framework and dive deep into its features. ",
      "location": "New York, NY, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-10T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-10T23:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3gi3kabkm3bua5lq3jhscc8s4c",
      "originalStartTime": {
       "dateTime": "2020-08-10T22:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3gi3kabkm3bua5lq3jhscc8s4c@google.com",
      "sequence": 2,
      "hangoutLink": "https://meet.google.com/xcb-hfjb-psv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/xcb-hfjb-psv",
         "label": "meet.google.com/xcb-hfjb-psv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/xcb-hfjb-psv?pin=4442155852117",
         "pin": "4442155852117"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081617300",
         "label": "+49 40 8081617300",
         "pin": "657955248"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "xcb-hfjb-psv",
       "signature": "AGirE/KwGYI6/tI3Q9TgjwEMhE+o"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187221506816000\"",
      "id": "48m09le389vijbqfs2mcr6i87q_20200811T070000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NDhtMDlsZTM4OXZpamJxZnMybWNyNmk4N3FfMjAyMDA4MTFUMDcwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:39:01.000Z",
      "updated": "2020-07-01T13:39:13.408Z",
      "summary": "Node Gang",
      "description": "We meet every Tuesday to talk about Node or JavaScript in general. Node Gang is an inclusive community that tries to cater to all levels of learners during meetups. Join us if you are curious to hear about what's new in Node, patterns, interesting npm packages, and practices.",
      "location": "Sydney NSW, Australia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-11T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-11T10:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "48m09le389vijbqfs2mcr6i87q",
      "originalStartTime": {
       "dateTime": "2020-08-11T09:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "48m09le389vijbqfs2mcr6i87q@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/wdc-wutt-tji",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/wdc-wutt-tji",
         "label": "meet.google.com/wdc-wutt-tji"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/wdc-wutt-tji?pin=3796108774207",
         "pin": "3796108774207"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618974",
         "label": "+49 40 8081618974",
         "pin": "170634768"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "wdc-wutt-tji",
       "signature": "AGirE/LhFDA0pcP/2mptu9nEhNEy"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232532588000\"",
      "id": "20c51je3q99mnolr1rp06dt9jd_20200811T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MjBjNTFqZTNxOTltbm9scjFycDA2ZHQ5amRfMjAyMDA4MTFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T14:17:12.000Z",
      "updated": "2020-07-01T15:11:06.294Z",
      "summary": "Use jQuery, bring in interactivity easily ",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Mumbai, Maharashtra, India",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-11T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-11T15:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "20c51je3q99mnolr1rp06dt9jd",
      "originalStartTime": {
       "dateTime": "2020-08-11T14:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "20c51je3q99mnolr1rp06dt9jd@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/nns-htdr-ijk",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/nns-htdr-ijk",
         "label": "meet.google.com/nns-htdr-ijk"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/nns-htdr-ijk?pin=9302146320475",
         "pin": "9302146320475"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618430",
         "label": "+49 40 8081618430",
         "pin": "810644618"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "nns-htdr-ijk",
       "signature": "AGirE/LKHWXbW3Hmf42CIofZT7zK"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200811T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA4MTFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-11T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-11T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
       "dateTime": "2020-08-11T16:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187238088812000\"",
      "id": "7e4k9oop7bb86svd42vui37k6o_20200811T150000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=N2U0azlvb3A3YmI4NnN2ZDQydnVpMzdrNm9fMjAyMDA4MTFUMTUwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:56:05.000Z",
      "updated": "2020-07-01T15:57:24.406Z",
      "summary": "Angular Moscow",
      "description": "Developed by Google, AngularJS is a relatively new JavaScript, and it is designed to make front-end development as easy as possible for you. \n\n\nJoin us to get introduced to this wonderful framework and dive deep into its features.",
      "location": "Moscow, Russia",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-11T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-11T18:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "7e4k9oop7bb86svd42vui37k6o",
      "originalStartTime": {
       "dateTime": "2020-08-11T17:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "7e4k9oop7bb86svd42vui37k6o@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/fip-gdth-tdu",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/fip-gdth-tdu",
         "label": "meet.google.com/fip-gdth-tdu"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/fip-gdth-tdu?pin=1369000914291",
         "pin": "1369000914291"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081616684",
         "label": "+49 40 8081616684",
         "pin": "516915292"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "fip-gdth-tdu",
       "signature": "AGirE/L64btreJwJIDJq962dEZU0"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232583216000\"",
      "id": "3m5n6mcl1aqrdsg6k5vkr6to5p_20200811T163000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M201bjZtY2wxYXFyZHNnNms1dmtyNnRvNXBfMjAyMDA4MTFUMTYzMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:54:32.000Z",
      "updated": "2020-07-01T15:11:31.608Z",
      "summary": "Build Your First App with JavaScript",
      "description": "You know basic HTML and CSS, and interested to learn the next thing about web development? Well, you are at the right place. Our workshop will take you to the amazing world of JavaScript. \n\nIn this workshop, you'll:\n- Learn JavaScript, from basics to advanced topics\n- Create your first app",
      "location": "Amsterdam, Netherlands",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-11T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-11T19:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3m5n6mcl1aqrdsg6k5vkr6to5p",
      "originalStartTime": {
       "dateTime": "2020-08-11T18:30:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3m5n6mcl1aqrdsg6k5vkr6to5p@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/vxc-jcvs-juv",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/vxc-jcvs-juv",
         "label": "meet.google.com/vxc-jcvs-juv"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/vxc-jcvs-juv?pin=7178471106778",
         "pin": "7178471106778"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081619886",
         "label": "+49 40 8081619886",
         "pin": "257304091"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "vxc-jcvs-juv",
       "signature": "AGirE/L1nRxxage7/xYEiTpkVsOW"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187232047578000\"",
      "id": "013qoq4ns44cam7q4hqcf13eab_20200811T230000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=MDEzcW9xNG5zNDRjYW03cTRocWNmMTNlYWJfMjAyMDA4MTFUMjMwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T15:05:49.000Z",
      "updated": "2020-07-01T15:07:03.789Z",
      "summary": "jQuery and More",
      "description": "Do you know jQuery is used by around 70 percent of the 10 million most popular websites as of May 2019? \n\nThough many consider it dead after Angular and Express gained popularity, jQuery is still an important part of many websites. \n\nIn our workshop, we teach basic to advanced jQuery where you will also be able to build a simple app using it. If you are familiar with JS, join us to learn probably its most popular library.",
      "location": "Santiago, Santiago Metropolitan Region, Chile",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-12T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-12T02:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "013qoq4ns44cam7q4hqcf13eab",
      "originalStartTime": {
       "dateTime": "2020-08-12T01:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "013qoq4ns44cam7q4hqcf13eab@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/mqx-jyfg-uoc",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/mqx-jyfg-uoc",
         "label": "meet.google.com/mqx-jyfg-uoc"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/mqx-jyfg-uoc?pin=9759553023326",
         "pin": "9759553023326"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618734",
         "label": "+49 40 8081618734",
         "pin": "678190650"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "mqx-jyfg-uoc",
       "signature": "AGirE/KiaAjBYNu1wvc5f9lZ14v5"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     },
     {
      "kind": "calendar#event",
      "etag": "\"3187222416180000\"",
      "id": "6co0ojl0l0j0rbh3g56vlc2s9i_20200812T010000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NmNvMG9qbDBsMGowcmJoM2c1NnZsYzJzOWlfMjAyMDA4MTJUMDEwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-07-01T13:44:15.000Z",
      "updated": "2020-07-01T13:46:48.090Z",
      "summary": "React California",
      "description": "React is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nReact California is a non-profit organization offering free training sessions to React enthusiasts every Wednesday and Friday.\n\nJoin us in our free React training sessions and give your career a new direction.",
      "location": "California, USA",
      "creator": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "organizer": {
       "email": "fullstackwebdev@careerfoundry.com",
       "self": true
      },
      "start": {
       "dateTime": "2020-08-12T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "end": {
       "dateTime": "2020-08-12T04:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "6co0ojl0l0j0rbh3g56vlc2s9i",
      "originalStartTime": {
       "dateTime": "2020-08-12T03:00:00+02:00",
       "timeZone": "Europe/Berlin"
      },
      "iCalUID": "6co0ojl0l0j0rbh3g56vlc2s9i@google.com",
      "sequence": 1,
      "hangoutLink": "https://meet.google.com/imt-kabh-cib",
      "conferenceData": {
       "entryPoints": [
        {
         "entryPointType": "video",
         "uri": "https://meet.google.com/imt-kabh-cib",
         "label": "meet.google.com/imt-kabh-cib"
        },
        {
         "entryPointType": "more",
         "uri": "https://tel.meet/imt-kabh-cib?pin=8711708481601",
         "pin": "8711708481601"
        },
        {
         "regionCode": "DE",
         "entryPointType": "phone",
         "uri": "tel:+49-40-8081618688",
         "label": "+49 40 8081618688",
         "pin": "752695860"
        }
       ],
       "conferenceSolution": {
        "key": {
         "type": "hangoutsMeet"
        },
        "name": "Google Meet",
        "iconUri": "https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_2x_web_512dp.png"
       },
       "conferenceId": "imt-kabh-cib",
       "signature": "AGirE/In05cchoOvbYk33gmlrnrg"
      },
      "reminders": {
       "useDefault": true
      },
      "eventType": "default"
     }

    ];
  
    export { mockData };
   